<template>
  <section v-if="content" class="section">
    <div class="container container-small row row-reverse" v-if="content">
      <div class="col">
        <div class="slide-in"
          :class="{
            'visible': visible
          }">
          <AccentHeader v-if="content.title" :underline="true" :header="content.title" :uppercase="false"/>
          <p v-if="content.description" class="text-m paragraph">
            {{ content.description }}
          </p>
          <ul v-if="content.items" class="text-m paragraph list-fancy">
            <li v-for="(item, index) in content.items" :key="'listitem' + index">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <div class="col text-center" v-if="image">
        <ImageWithAnimation
          :id="image"
          color="accent"
          :loop="true"
          :visible="visible" />
      </div>
    </div>
  </section>
</template>
<script>
import AccentHeader from '@/components/AccentHeader.vue'
import ImageWithAnimation from '@/components/ImageWithAnimation.vue'

export default {
  name: 'ReverseColumsWithAnimatedImage',
  props: ['content', 'image', 'visible'],
  components: {
    AccentHeader,
    ImageWithAnimation
  }
}
</script>

<style scoped lang="scss">
.section {
  padding: $gap-xl 0;

  @include screen ('md') {
    padding: ceil($gap-xl * 1.5) 0;

    .text-center {
      text-align: left;
    }
  }

  p, ul, ol, dl {
    padding: $gap-lg 0 $gap-xl;
  }
}
</style>
